/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Strategy impact ratings
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type StrategyImpactRatingEnum = 'Low' | 'Medium' | 'High' | 'Very High';

export const StrategyImpactRatingEnum = {
    Low: 'Low' as StrategyImpactRatingEnum,
    Medium: 'Medium' as StrategyImpactRatingEnum,
    High: 'High' as StrategyImpactRatingEnum,
    VeryHigh: 'Very High' as StrategyImpactRatingEnum
};

marker('Low');
marker('Medium');
marker('High');
marker('Very High');

